import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { connect } from 'react-redux';
import { MSGERROR, MSGOK, traducirPagina, obtenerUsuario } from "../../librerias/funciones"
import {
    CloseOutlined,
    SaveOutlined,

} from '@ant-design/icons';
import { Select, Drawer, Input, Checkbox, Row, Col, Tabs } from 'antd';

const { Option } = Select;
const { TabPane } = Tabs;
const CheckboxGroup = Checkbox.Group;

const FichaInfoConsulta = ({ props, configApp }) => {
    const [hayDatos, setHayDatos] = React.useState(false);



    if (!hayDatos && props.ABRIR_FICHA) {
        setHayDatos(true);

    } else {
        if (!props.ABRIR_FICHA && hayDatos) {
            setHayDatos(false);
        }
    }



    return (
        <Drawer
            width={configApp.width <= 900 ? '100%' : 800}
            onClose={() => {
                //props.MODIFICA_ENVIO_FEED_BACK(false)
                props.CERRAR_FICHA(false)
            }}
            closable={false}

            visible={props.ABRIR_FICHA}
            placement={"right"}
            bodyStyle={{ padding: '0px' }}
            style={{ color: '#fff' }}>


            <div className='containerHeaderDrawer'>
                <div className='itemHeaderDrawer1'>
                    <CloseOutlined onClick={(e) => { props.CERRAR_FICHA(false) }}></CloseOutlined>
                    <div>  {props.title}</div>
                </div>
            </div>


            {props.HTML_TAREA === null ?
                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <h4>{traducirPagina("Msg_sin_resultados")}</h4>
                </div>
                :
                props.HTML_TAREA === "" ?
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '80vh', color: '#000' }}> <div className="spinner-border fast colorSubAzul" role="status" disabled /> </div>

                    :
                    <div className='body_feedback' style={{ overflow: 'auto' }} dangerouslySetInnerHTML={{ __html: (props.HTML_TAREA) }}>
                    </div>
            }



        </Drawer>

    )
}

FichaInfoConsulta.propTypes = {
    title: PropTypes.string,
    ABRIR_FICHA: PropTypes.bool,
    CERRAR_FICHA: PropTypes.func,
    HTML_TAREA: PropTypes.string,
};

const mapStateToProps = (state, props) => {
    return {
        configApp: state.configApp,
        props: props,

    };
}

export default connect(mapStateToProps)(FichaInfoConsulta);